import ApiModel from 'models/api-model';
const chatbotFeatureFlags = ['ENABLE_CHATBOT', 'ENABLE_CHATBOT_FEEDBACK'];

// each response.featureFlags[chatbotFeatureFlags[0]] will contain object as response
/*
project 
clientLevelFeatureEnabled: true
geoLevelFeatureEnabled: false
memberFirmLevelFeatureEnabled: false

projectFeedBack
"geoLevelFeatureEnabled": true,
"memberFirmLevelFeatureEnabled": false,
"clientLevelFeatureEnabled": true
*/
export class ChatbotFeatureFlags extends ApiModel({
  data: {
    project: {},
    feedback: {},
  },
}) {
  processResponse({ response }) {
    return {
      data: {
        project: response?.featureFlags[chatbotFeatureFlags[0]],
        feedBack: response?.featureFlags[chatbotFeatureFlags[1]],
      },
    };
  }

  get chatbotFeatureFlags() {
    return this.data;
  }

  get isChatbotEnabledForCurrentProject() {
    const projectFeature = this.data.project;
    if (projectFeature) {
      return (
        projectFeature?.geoLevelFeatureEnabled &&
        projectFeature?.memberFirmLevelFeatureEnabled &&
        projectFeature?.clientLevelFeatureEnabled
      );
    } else {
      return false;
    }
  }

  get isChatbotEnabledForProjectFeedBack() {
    const projectFeedBackFeature = this.data.feedBack;
    if (projectFeedBackFeature) {
      return (
        projectFeedBackFeature?.geoLevelFeatureEnabled &&
        projectFeedBackFeature?.memberFirmLevelFeatureEnabled &&
        projectFeedBackFeature?.clientLevelFeatureEnabled
      );
    }
    return false;
  }
}
